import { Badge } from '@/components/ui';
import { MetricCard } from './MetricCard';

/**
 * Big "visitors right now" stat card. Counts visits in the last 5 minutes
 * — window is intentionally wider than Cloudflare Analytics Engine's
 * ~30s ingest latency so the number reads as genuinely live (a 1-minute
 * window would mostly read 0 and feel broken).
 *
 * Renders via the shared MetricCard primitive so the bottom row aligns
 * with the other cards on the same row regardless of content height.
 */
export function LiveNowCard({ liveNow }: { liveNow: number }) {
  const isLive = liveNow > 0;
  return (
    <MetricCard
      label="Live now"
      labelIcon={
        <span
          aria-hidden
          className={`inline-block h-2 w-2 rounded-full ${
            isLive ? 'animate-pulse bg-[#cdbdff]' : 'bg-[var(--color-on-surface-variant)]/40'
          }`}
        />
      }
      value={liveNow.toLocaleString()}
      badge={isLive ? <Badge tone="primary">on your links right now</Badge> : null}
      meta={
        <span title="Window is 5 minutes — wider than Cloudflare Analytics Engine's ~30s ingest latency, so the number reads as genuinely live.">
          {isLive ? 'last 5 min' : 'no one in the last 5 min'}
        </span>
      }
    />
  );
}
